import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { useEffect, useState } from "react";

interface SearchInputProps {
	placeholder?: string;
	/** Called with the debounced value. */
	onSearch: (value: string) => void;
	delay?: number;
	className?: string;
}

/**
 * Debounced search box. Keeps its own value so typing stays responsive while the
 * list query only re-runs once the user pauses.
 */
export function SearchInput({
	placeholder = "Qidirish…",
	onSearch,
	delay = 350,
	className = "",
}: SearchInputProps) {
	const [value, setValue] = useState("");

	useEffect(() => {
		const timer = setTimeout(() => onSearch(value.trim()), delay);
		return () => clearTimeout(timer);
	}, [value, delay, onSearch]);

	return (
		<Input
			value={value}
			onChange={(event) => setValue(event.target.value)}
			placeholder={placeholder}
			prefix={<SearchOutlined className="text-[var(--c-text-muted)]" />}
			allowClear
			className={className}
		/>
	);
}
